import React from "react";
import Icon from "./Icon";

export const AddonCheckedIcon = () => (
  <Icon>
    <circle cx="12" cy="12" r="12" fill="#D7E6D5"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.75047 15.1275L7.14797 12.525C6.85547 12.2325 6.38297 12.2325 6.09047 12.525C5.79797 12.8175 5.79797 13.29 6.09047 13.5825L9.22547 16.7175C9.51797 17.01 9.99047 17.01 10.283 16.7175L18.218 8.7825C18.5105 8.49 18.5105 8.0175 18.218 7.725C17.9255 7.4325 17.453 7.4325 17.1605 7.725L9.75047 15.1275Z" fill="#39842B"/>
  </Icon>
);
